import { h, render } from 'preact';
import App from './App';

// Declare global function type
declare global {
  interface Window {
    renderProductTile: (container: HTMLElement, hit: any, filters: any) => void;
  }
}

// Global function to render product tile
window.renderProductTile = (container: HTMLElement, hit: any, filters: any) => {
  render(<App hit={hit} filters={filters} />, container);
};

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('product-tiles-container');
  if (rootElement) {
    render(<App />, rootElement);
  }
}); 